<template>
	<div class="messages">
		<div
			v-for="(message, i) in messages"
			:key="'message-' + i"
			class="message"
		>
			<span>{{ message }}</span>
		</div>
	</div>
</template>

<script>
export default {

	props: {
		messages: {
			type: Array,
			required: true,
		},
	},
}
</script>
